import axios from 'axios'
import AscentiaService from './ascentiaService'
const values = {
  allUserGuides: null,
  userGuideById: null,
  userContentTypes: null,
  userContentById: null,
  userGuide: null,
  userContent: null,
}

const getters = {
  allUserGuides() {
    return axios.get('/UserGuide')
  },
  userGuideById(userGuideId) {
    if (userGuideId)
      return axios.get(`/UserGuide/${userGuideId}`, {
        responseType: 'blob',
      })
  },
  userContentTypes() {
    return axios.get('/UserUpdatedContent/UserUpdatedContentTypes')
  },

  async allUserContents({ data }) {
    const contentData = data.map(async contentType => {
      try {
        const res = await axios.get(`/UserUpdatedContent/${contentType.id}`)
        const data = res.data
          ? res.data
          : {
              content: '',
              lastUpdatedOn: null,
              updatedById: null,
              typeId: contentType.id,
            }
        return {
          ...contentType,
          ...data,
        }
      } catch (error) {
        return error
      }
    })
    return axios.all(contentData)
  },
  userContentById(typeId) {
    return axios.get(`/UserUpdatedContent/${typeId}`)
  },
}

const saves = {
  userGuide(userGuide) {
    if (userGuide) {
      const formData = new FormData()
      userGuide.companyIds.map(companyId =>
        formData.append('CompanyIds', companyId),
      )

      if (userGuide.userGuide) formData.append('UserGuide', userGuide.userGuide)

      // If the save has Id then its an update
      if (userGuide.id) return axios.put(`/UserGuide/${userGuide.id}`, formData)
      else return axios.post('/UserGuide', formData)
    }
  },
  userContent(content) {
    if (content.typeId && content.content) {
      const contentString = JSON.stringify(content.content)

      return axios
        .put(`/UserUpdatedContent/${content.typeId}`, contentString, {
          head: { 'Content-Type': 'application/json' },
        })
        .catch(error => error)
    }
  },
}
const deletes = {
  userGuide(userGuideIDs) {
    const list = userGuideIDs.map(userGuideID => {
      return axios.delete(`/UserGuide/${userGuideID}`)
    }) //////////////////////
    return axios.all(list)
  },
}
export default class UserGuideService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
